// src/stone/illustrations/StonjiBoletoIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiBoletoIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx("rect", { width: 34.333, height: 48, x: 15, y: 8, fill: "#fff", rx: 1.667 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M22.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1M26.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1M30.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1M34.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1M38.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1M42.333 37.189a1 1 0 0 1-1-1V28a1 1 0 0 1 2 0v8.189a1 1 0 0 1-1 1"
        }
      )
    ]
  }
);
var StonjiBoletoIllustration_default = StonjiBoletoIllustration;

export {
  StonjiBoletoIllustration_default
};
